export const EMAIL_CONTENT_LIST = "EMAIL_CONTENT_LIST";
export const EMAIl_CONTENT_GET_FILTER_DATA = "EMAIl_CONTENT_GET_FILTER_DATA";
export const EMAIL_CONTENT_SHOW = "EMAIL_CONTENT_SHOW";
export const EMAIL_CONTENT_CREATE = "EMAIL_CONTENT_CREATE";
export const EMAIL_CONTENT_STORE = "EMAIL_CONTENT_STORE";
export const EMAIL_CONTENT_EDIT = "EMAIL_CONTENT_EDIT";
export const EMAIL_CONTENT_UPDATE = "EMAIL_CONTENT_UPDATE";


